<template>
  <div class="kitchen">
    <div class="kitchen-content">
      <!-- v-if="!isCanteenAdmin" -->
      <div class="top" >
        <div class="canteen-name">
          <div class="canteen-title">食堂名称</div>
          <el-select v-model="canteen" placeholder="请选择" class="w200" clearable @change="change">
            <el-option
              v-for="item in canteenList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="kitchen-container">
        <div class="kitchent-week-title">
          <div class="kitchen-week"
            v-for="(item, index) in weekList"
            :key="index"
          >
            {{item}}
          </div>
        </div>
        <div class="kitchen-set">
          <div class="kitchen-date"
            v-for="(item, i) in dateList"
            :key="i"
          >
            <div
              class="every-day"
              v-for="(v, idx) in item.dayBoList"
              :key="idx"
            >
              <div class="date-title">
                <div class="date-title-left">
                  <el-button
                    v-if="v.futureFlag && OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleHelpChiefSetting
              ) !== -1"
                    type="text"
                    class="btn-text"
                    @click="openSetKitchen(v.timestamp, v.monitorUserId)"
                    >设置</el-button
                  >
                </div>
                <div class="date-title-right">
                  <div class="today" v-if="v.todayFlag">今</div>
                  <div class="date">{{v.date}}</div>
                </div>
              </div>
              <div class="date-content"
              >
                <div
                  v-for="(val, index) in v.itemList"
                  :key="index"
                  class="kitchen-name"
                  :class="[val.monitorFlag == 1?'dash':'',index%2?'active ':'']"
                  @click="clickKitchenName(`${i}-${idx}-${index}`)"
                >
                  <i v-if="activeIndex == `${i}-${idx}-${index}` && v.futureFlag" class="el-icon-error" @click="delKitchen(val.id, val.monitorFlag, v.monitorId)"></i>
                  <div class="kitchen-people">
                    {{val.userName}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    
    <!-- 设置帮厨 -->
    <el-dialog
      title="设置帮厨人员"
      :visible.sync="dialogVisible"
      width="840px"
      :before-close="kitchenClose"
    >
      <div class="stayDistribution">
        <div class="table-left">
          <tree
            :isSearch="isSearch"
            :companyList="staffAndDepartmentList"
            :departmentId="assignDepartmentId"
            @selectTreeNodeList="selectAssignDepartment"
          />
        </div>
        <div class="table table-right">
          <div class="search-table">
            <el-input
              class="gray white"
              @keyup.enter.native="searchAssignPeople"
              v-model="staff"
              placeholder="请输入成员"
            ></el-input>
          </div>
          <el-table
            :data="assignPeople"
            style="width: 100%"
            height="250"
            ref="staff"
            @selection-change="handleSelectionSKitchenChange"
          >
            <el-table-column type="selection" width="60"> </el-table-column>
            <el-table-column prop="name" label="姓名">
              <template slot-scope="scope">
                <div class="assign-name">
                  <img :src="scope.row.image">
                  <span>{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.monitorUserId"
                  type="text"
                  class="btn-text"
                  :disabled="isMonitor"
                  :class="isMonitor?'disabled-monitor':''"
                  @click="setMonitor(scope.row)"
                  >设为班长</el-button
                >
                <el-button
                  v-else
                  type="text"
                  class="btn-text"
                  @click="delMonitor(scope.row)"
                  >删除班长</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="stayDistributionTotalNum"
              :currentPage="stayDistributionCurrentPage"
              @queryChange="stayDistributionOnQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="kitchenClose"
          >取 消</el-button
        >
        <el-button type="primary" @click="kitchenConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import Kitchen from "@/models/kitchen.js"
import Canteen from "@/models/canteen.js";
import Staff from "@/models/staff.js";
import Tree from "@/components/Tree.vue";
import PaginationTpl from "@/components/PaginationTpl.vue";
import { getTeamId } from "common/js/storage";
import { mapChild, mapId2, formatTimeToDate } from "@/common/js/utils.js";
import { operationMixins } from "@/common/mixins/operation/operation.js";
export default {
  mixins: [operationMixins],
  components: {
    Tree,
    PaginationTpl
  },

  data() {
    return {
      /* 是否是食堂管理员; 1.是， 0，不是 */
      isCanteenAdmin: 1,
      canteen: '',
      canteenList: [],
      dateList: [],
      weekList: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      activeIndex: null,
      
      assignDepartmentId: 0,
      dialogVisible: false,
      isSearch: false,
      staff: "",
      date: "",
      assignPeople: [],
      staffAndDepartmentList: [],
      selectAssignPeople: [],
      stayDistributionTotalNum: 0,
      stayDistributionCurrentPage: 1,

      isMonitor: false,
      /* 值班班长id */
      monitorUserId: 0
    }
  },

  async created() {
    config()
    await this.initCanteenList()
    this.initKitchenList()
    this.initDepartmentList()
  },

  methods: {
    /* 获取帮厨列表 */
    initKitchenList() {
      let canteenId = this.canteen
      Kitchen.getKitchenList(canteenId).then(res => {
        if (res.success) {
          let { mon, tues, thur, wed, fri, sat, sun } = res.result
          this.dateList = [
            mon,
            tues,
            wed,
            thur,
            fri,
            sat,
            sun
          ]
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取食堂数据 */
    async initCanteenList() {
      let res = await Canteen.getCanteenNoPageList()
      if (res.success) {
        let arr = []
        res.result.map(i => {
          let obj = {}
          obj.id = i.id
          obj.name = i.name
          arr.push(obj)
        })
        this.canteenList = arr
        this.canteen = arr.length > 0 ? arr[0].id : ''
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },

    /* 获取部门数据 */
    initDepartmentList() {
      let searchDepartment = ''
      let id = ''
      let keyword = 'food'
      Staff.getChangeDepartmentList(id, searchDepartment, keyword).then(res => {
        if (res.success) {
          let arr = mapChild(res.result);
          this.staffAndDepartmentList = mapId2(arr)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    initStaffList() {
      let searchDepartment = this.staff
      let id = this.assignDepartmentId != 0? this.assignDepartmentId: getTeamId()
      let currentPage = this.stayDistributionCurrentPage
      Staff.getPeopleList(id, searchDepartment, currentPage).then(res => {
        if (res.success) {
          this.stayDistributionTotalNum = res.result.totalNum
          let arr = [];
          res.result.items.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.phone = i.phoneNo;
            obj.image = i.image;
            if (this.monitorUserId && i.id==this.monitorUserId) {
              obj.monitorUserId = this.monitorUserId;
            } else {
              obj.monitorUserId = 0;
            }
            arr.push(obj);
          });
          this.assignPeople = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    change() {
      this.initKitchenList();
    },

    clickKitchenName(index) {
      this.activeIndex = index
    },

    /* 删除帮厨 */
    delKitchen(id, monitorFlag, monitorId) {
      let data = {
        id: monitorFlag?monitorId:id,
        monitorFlag
      }
      Kitchen.postDelKitchen(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.activeIndex = null
          this.initKitchenList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 打开设置帮厨 */
    openSetKitchen(v, id) {
      this.monitorUserId = id
      if (id) {
        this.isMonitor = true
      } else {
        this.isMonitor = false
      }
      this.date = formatTimeToDate(v)
      this.dialogVisible = true
    },

    kitchenClose() {
      this.staff = "",
      this.date = "",
      this.selectAssignPeople = []
      this.assignPeople = []
      this.assignDepartmentId = 0
      this.dialogVisible = false;
    },

    /* 帮厨人员多选 */
    handleSelectionSKitchenChange(val) {
      let arr = []
      val.map(i => {
        arr.push(i.id)
      })
      this.selectAssignPeople = arr
    },

    /* 帮厨人员确认 */
    kitchenConfirm() {
      let canteenId = this.canteen
      let date = this.date
      let userIdList = this.selectAssignPeople
      let monitorUserId = this.monitorUserId
      // if (userIdList.indexOf(monitorUserId) == -1) return this.$message.error('请选择班长')
      let data = {
        canteenId,
        date,
        userIdList,
        monitorUserId
      }
      Kitchen.postAddKitchen(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '设置成功'
          });
          this.kitchenClose()
          this.initKitchenList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    
    /* 翻页 */
    stayDistributionOnQueryChange(data) {
      this.stayDistributionCurrentPage = data.currentPage;
      this.initStaffList()
    },

    selectAssignDepartment(v) {
      this.assignDepartmentId = v.id
      this.initStaffList()
    },
    searchAssignPeople() {
      this.stayDistributionCurrentPage = 1
      this.initStaffList()
    },
    setMonitor(row) {
      row.monitorUserId = row.id
      this.monitorUserId = row.id
      this.isMonitor = true
      this.$refs['staff'].toggleRowSelection(row, true)
    },
    delMonitor(row) {
      this.isMonitor = false
      row.monitorUserId = 0
      this.monitorUserId = 0
      this.$refs['staff'].toggleRowSelection(row, false)
    }
  }
}
</script>

<style lang='scss'>
.kitchen {
  flex: 1;
  background: $bg-white;
  .kitchen-content {
    height: 100%
  }
  .top {
    @include flex-start;
    padding: 20px;
    .el-button {
      padding: 0px;
    }
    .canteen-name {
      @include flex-center;
      font-size: $fs-small-l;
      border: 1px solid $bg-ShallowLightSnow;
      .canteen-title {
        height: 32px;
        line-height: 32px;
        padding-left: 19px;
        font-weight: 400;
        color: $color-LightGrey;
      }
      .el-input__inner {
        border: none;
      }
    }
  }
  .kitchen-container {
    .kitchent-week-title {
      border-bottom: 1px solid $bg-ShallowLightSnow;
      @include flex-center;
      .kitchen-week {
        display: inline-block;
        width: 14.28%;
        height: 56px;
        line-height: 56px;
        font-size: $fs-medium-m;
        font-weight: 400;
        color: $color-LightGrey;
      }
    }
    .kitchen-set {
      display: flex;
      align-content: flex-start;
      margin-bottom: 20px;
      .kitchen-date {
        width: 14.28%;
        box-sizing: border-box;
        .every-day {
          @include flex-column-start;
          height: 140px;
          padding: 15px 10px 40px 10px;
          @include scrollbarNotrack;
          overflow-y: auto;
          border-bottom: 1px solid $bg-ShallowLightSnow;
          border-right: 1px solid $bg-ShallowLightSnow;
          .date-title {
            width: 100%;
            @include flex-between;
            margin-bottom: 10px;
            .date-title-left {
              width: 20%;
              text-align: left;
              font-size: 14px;
              font-weight: 400;
              color: $color-DepartmentPeople;
            }
            .date-title-right {
              width: 80%;
              @include flex-between;
              position: relative;
              .today {
                position: absolute;
                right: 52%;
                width: 24px;
                height: 24px;
                line-height: 24px;
                background: $bg-DeepOriginYellow;
                border-radius: 50%;
                font-size: 14px;
                font-weight: 400;
                color: $color-white;
              }
              .date {
                flex: 1;
                width: 100%;
                text-align: right;
                font-size: 30px;
                font-family: DIN;
                font-weight: 500;
                color: $color-BlackGrey;
              }
            }
          }
          .date-content {
            width: 100%;
            height: 103px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            .active {
              margin-right: 0px !important;
            }
            .kitchen-name {
              width: 46.5%;
              height: 32px;
              line-height: 32px;
              margin-right: 6px;
              margin-bottom: 10px;
              font-size: $fs-small-l;
              font-weight: 400;
              color: $color-grey;
              border: 1px dashed $bg-DoopLightSnow;
              position: relative;
              .el-icon-error {
                position: absolute;
                top: -7px;
                right: -7px;
              }
              .kitchen-people {
                width: 100%;
                height: 100%;
                @include two-wrap-ellipsis(1);
              }
            }
            .dash {
              border-color: $color-DepartmentPeople;
            }
          }
        }
      }
    }
  }
  .assign-name {
    img {
      width: 24px;
      height: 24px;
      margin-right: 6px;
    }
  }
  .stayDistribution {
    display: flex;
    .table-left {
      width: 370px;
      height: 394px;
      padding: 20px;
      border-right: 1px solid $bg-ShallowLightSnow;
      box-sizing: border-box;
      overflow: hidden;
      overflow-y: auto;
      @include scrollbarNotrack();
    }
    .table-right {
      flex: 1;
      padding: 20px;
      box-sizing: border-box;
      overflow: hidden;
      .search-table {
        margin-bottom: 20px;
      }
    }
  }
  .disabled-monitor {
    color: $color-FinancialAudit!important;
  }
}
</style>
